import { lazy } from "react";
export const compData = [
  {
    path: "/trang-chu",
    compPath: lazy(() => import("./components/screen/home/home")),
  },
  {
    path: "/profile",
    compPath: lazy(() => import("./components/screen/UserManager/ProfilePage")),
  },
  {
    path: "/tao-don-hang",
    compPath: lazy(() => import("./components/screen/OrderManager/FormOrder")),
  },
  {
    path: "/orders/list",
    compPath: lazy(() =>
      import("./components/screen/OrderManager/OrderManager")
    ),
  },
  {
    path: "/system/menus",
    compPath: lazy(() => import("./components/screen/Menumanager/IndexMenu")),
  },
  {
    path: "/system/settings",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/IndexConfigSysterm")
    ),
  },
  {
    path: "/system/despositfee",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/DespositFeeTable")
    ),
  },
  {
    path: "/system/weightfee",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/WeightFeeTable")
    ),
  },
  {
    path: "/system/purchasefee",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/PurchaseFeeTable")
    ),
  },
  {
    path: "/system/rate",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/ExchangeRateTable")
    ),
  },
  {
    path: "/system/bank-account",
    compPath: lazy(() =>
      import("./components/screen/ConfigSysterm/AdminBankAccount")
    ),
  },
  {
    path: "/system/provider",
    compPath: lazy(() => import("./components/screen/MatterData/Provider")),
  },
  {
    path: "/system/surcharge-types",
    compPath: lazy(() =>
      import("./components/screen/MatterData/SurchargeTypes")
    ),
  },
  {
    path: "/finance/payments",
    compPath: lazy(() => import("./components/screen/Payment/IndexPayment")),
  },
  {
    path: "/dashboard",
    compPath: lazy(() => import("./components/screen/home/home")),
  },
  {
    path: "/tracking-number",
    compPath: lazy(() =>
      import("./components/screen/WareHouse/IndexTrackingNumber")
    ),
  },
  {
    path: "/warehouse/tracking-manager",
    compPath: lazy(() =>
      import("./components/screen/WareHouse/TrackingManager")
    ),
  },
  {
    path: "/package",
    compPath: lazy(() => import("./components/screen/WareHouse/IndexPackage")),
  },
  {
    path: "/warehouse/warehouse-local",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/IndexWareHouseLocal")
    ),
  },
  {
    path: "/view-detail-receipt",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/ViewDetailWareHouseReceipt")
    ),
  },
  {
    path: "/warehouse/receipt-list",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/IndexWareHouseReceipt")
    ),
  },
  {
    path: "/warehouse/receipt-create",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/FormReceipt")
    ),
  },
  {
    path: "/tracking-number-local",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/IndexTrackingNumberLocal")
    ),
  },
  {
    path: "/warehousevn/delivery",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/DeliveryRequest")
    ),
  },
  {
    path: "/delivery-detail-receipt",
    compPath: lazy(() =>
      import("./components/screen/WareHouseLocal/FormDeliverRequest")
    ),
  },
  {
    path: "/system/users",
    compPath: lazy(() =>
      import("./components/screen/UserManager/IndexUserManager")
    ),
  },
  {
    path: "/system/list-custormer",
    compPath: lazy(() =>
      import("./components/screen/UserManager/IndexUserManager")
    ),
  },
  {
    path: "/consignment/list",
    compPath: lazy(() =>
      import("./components/screen/Consignment/ConsignmentManager")
    ),
  },
  {
    path: "/finance/history",
    compPath: lazy(() => import("./components/screen/Payment/HistoryPayment")),
  },
  {
    path: "/consignment-directions/list",
    compPath: lazy(() =>
      import("./components/screen/Consignment/IndexConsigmentDirection")
    ),
  },
  {
    path: "/report/purchase-statistics",
    compPath: lazy(() =>
      import("./components/screen/Report/IndexPurchaseReport")
    ),
  },
  {
    path: "/report/consignment-statistics",
    compPath: lazy(() =>
      import("./components/screen/Report/IndexConsignmentReport")
    ),
  },
  {
    path: "/report/sale-statistics",
    compPath: lazy(() =>
      import("./components/screen/Report/IndexSaleReport")
    ),
  },
];
